import axios from "axios";

const api = axios.create({
  baseURL: ``,
  withCredentials: true,
  headers: {
    'Cache-Control': 'no-cache',
  },
});

// Inject JWT token into every request (user or admin session)
api.interceptors.request.use(
  (config) => {
    const token =
      (typeof window !== "undefined" && window.location.pathname.startsWith("/management"))
        ? sessionStorage.getItem("adminToken")
        : sessionStorage.getItem("authToken");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 globally — clear session and redirect to the right login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname || '';
      const isManagement = path.startsWith('/management');
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("user");
      if (isManagement) {
        sessionStorage.removeItem("adminToken");
        sessionStorage.removeItem("adminUser");
        if (path !== '/management') {
          window.location.href = '/management';
        }
      } else if (path !== '/login' && path !== '/home' && path !== '/register') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
